    import * as CryptoJS from 'crypto-js';
import { AppConstants } from '../app-constants';
import { Injectable } from '@angular/core';

var keySize = 256;
var iterations = 100;
@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptUtil {

    
encrypt(msg: any): string {
  // Step 1: Random secret key for PBKDF2
  const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString(); // 16 bytes key string

  // Step 2: Generate random salt and IV
  const salt = CryptoJS.lib.WordArray.random(128 / 8); // 16 bytes
  const iv = CryptoJS.lib.WordArray.random(128 / 8);   // 16 bytes

  // Step 3: Derive key using PBKDF2
  const key = CryptoJS.PBKDF2(secretKey, salt, {
    keySize: keySize / 32,   // Example: 256 / 32 = 8
    iterations: iterations   // Must match decryption iterations
  });

  // Step 4: Encrypt the message (stringify if needed)
  const encrypted = CryptoJS.AES.encrypt(
    typeof msg === 'string' ? msg : JSON.stringify(msg),
    key,
    {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    }
  );

  // Step 5: Morph the parts (salt, iv, encrypted, secretKey)
  const saltHex = this.morphString(salt.toString(CryptoJS.enc.Hex));
  const ivHex = this.morphString(iv.toString(CryptoJS.enc.Hex));
  const encryptedBase64 = encrypted.toString(); // Base64-encoded ciphertext
  const morphedKey = this.morphString(secretKey);

  // Step 6: Join all parts with separator (ensure it's same as used in decrypt)
  const encryptedMessage = [
    saltHex,
    ivHex,
    encryptedBase64,
    morphedKey
  ].join(AppConstants.ENC_seprator);

  return encryptedMessage;
}

 morphString(inStr: string): string {
  const rules = AppConstants.ENC_RULES;
  for (const [char, morphVal] of Object.entries(rules)) {
    inStr = inStr.split(char).join(morphVal);
  }
  return inStr;
}





   decrypt(transitmessage: string): string {
  
      var transitmessageArr = transitmessage.split(AppConstants.ENC_seprator);
      // console.log(transitmessageArr,'decrypt1')
    var salt = CryptoJS.enc.Hex.parse(this.demorphString(transitmessageArr[0]));
    //  console.log(salt,'decrypt 2')
    var iv = CryptoJS.enc.Hex.parse(this.demorphString(transitmessageArr[1]));
    //  console.log(salt,'decrypt 3')
    var encrypted = transitmessageArr[2];
      //  console.log(encrypted,'decrypt 4')
    var secret_key = this.demorphString(transitmessageArr[3]);
    //  console.log(secret_key,'decrypt 5')
    var key = CryptoJS.PBKDF2(secret_key, salt, {
      keySize: keySize / 32,
      iterations: iterations
    });
  //  console.log(secret_key,'decrypt 6')
    // var decrypted = crypto.AES.decrypt(encrypted, key, {
    //   iv: iv,
    //   padding: crypto.pad.Pkcs7,
    //   mode: crypto.mode.CBC
    // });
    //  console.log(decrypted,'decrypt 7')
    // return decrypted.toString(crypto.enc.Utf8);
    const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
   

  }
  demorphString(morphedKey:any):any {
    const rules = AppConstants.ENC_RULES;
    for (const rule of Object.entries(rules)) {
      let [char, morphedValue] = rule;
      while (morphedKey.includes(morphedValue)) {
        morphedKey = morphedKey.replace(morphedValue, char);
      }
    }
    return morphedKey;

  }

}
